<template>
  <div class="p-2 sm:p-4">
    <div class='flex justify-between items-center'>
      <div>
        <h1>Premium Payouts</h1>
      </div>
      <div class="flex flex-col text-right justify-end">
        <a class="btn btn-green" target="_blank" :href="`/premiums_report?event_id=${event.event_id}`">Print Premium Report</a>
      </div>
    </div>
    <div class="hr"></div>
    <tabs>
      <tab :selected="true" name="Payout Data" class="max-w-5xl">
        <div class="my-5 flex justify-end space-x-3">
          <button class="btn-link" v-if="premiumList.length" @click="$refs.downloadData.exportCSVFile(`${event.name}_premium_payouts`,premiumPayoutdata, premiumHeaders)">Download Data</button>
          <button class="btn-sm btn-blue" @click="getPayoutData">Load Payout Data</button>
        </div>
        <showman-table class="mt-4" :tableData="premiumList" :tableFields="premiumFields" :condensed="true">
          <div slot="premium_total" slot-scope="data" class="">
            <div class="text-right">
              <p class="text-xl">{{currencySymbol}}{{data.item.premium_total.toFixed(2)}}</p>
              <button class="btn-link" @click="viewPremiumDetails(data.item)">View Details</button>
            </div>
          </div>
          <div slot="address" slot-scope="data" class="">
            <div class="text-xs">{{data.item.user.address.address_line1}}</div>
            <div class="text-xs">{{data.item.user.address.city}}, {{data.item.user.address.state}} {{data.item.user.address.zip}}</div>
          </div>
          <div slot="exhibitor" slot-scope="data" class="flex flex-shrink-0 w-48">
            <div class="flex-shrink-0">
              <div class="font-medium">{{data.item.exhibitor.first_name}} {{data.item.exhibitor.last_name}}</div>
            </div>
          </div>
        </showman-table>
      </tab>
      <tab name="Payout Settings" v-if="adminData.event.event_settings.premium_payout_settings">
        <div class="mt-2 flex justify-between items-center space-x-3 border-b py-4">
          <div>
            <label id="listbox-label" class="block text-xl font-medium leading-6 text-gray-900 mb-2">Payout Grouping</label>
            <v-select
              class="rounded w-full  md:w-128"
              v-model="payoutGroup"
              :options="adminData.event.event_settings.premium_payout_settings.payout_groups"
              label="label"
              :clearable="false"
            >
            </v-select>
          </div>
          <button class="btn btn-blue" @click="updateEvent">Update Settings</button>
        </div>
        <div>
          <template v-if="!payoutGroup">
            <p class="mt-8 text-2xl text-center">Select a payout group to view settings</p>
          </template>
          <template v-else>
            <div class="flex flex-col md:flex-row md:items-center md:justify-between bg-gray-200 py-5 px-2 mb-2 rounded-b">
              <p class="text-2xl pb-2 w-128">{{payoutGroup.label}}</p>
              <div class="w-full">
                <label for="show" class="block text-lg font-medium text-gray-700 mb-1">Shows</label>
                <multiselect v-model="payoutGroup.shows" :options="showList" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" placeholder="Select a show to enter" label="name" track-by="name" :preselect-first="false" :custom-label="(option) => {return option.name}" :hideSelected="true"></multiselect>
              </div>
            </div>
            <div class="flex flex-col justify-start space-y-5">
              <div>
                <div class="p-1 mb-2 border-b text-lg">
                  <p>Class Placings</p>
                  <div class="relative flex items-start">
                    <div class="flex h-5 items-center">
                      <input v-model="payoutGroup.class_size_variation" id="comments" aria-describedby="comments-description" name="comments" type="checkbox" class="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500">
                    </div>
                    <div class="ml-3 text-sm">
                      <label for="comments" class="font-medium text-gray-700">Class Size Variation?</label>
                    </div>
                  </div>
                  <div class="relative flex items-start">
                    <div class="flex h-5 items-center">
                      <input v-model="payoutGroup.class_percentage_based" id="comments" aria-describedby="comments-description" name="comments" type="checkbox" class="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500">
                    </div>
                    <div class="ml-3 text-sm">
                      <label for="comments" class="font-medium text-gray-700">Percentage based?</label>
                    </div>
                  </div>
                  <div v-if="payoutGroup.class_percentage_based" class="flex items-center">
                      <label class="font-medium text-gray-700 text-sm mr-1">Added Money?</label>
                      <input v-model.number="payoutGroup.class_added_money" type="number" class="border p-1 rounded w-16 text-sm">
                      <p class="ml-1 text-xs font-medium">**This amount will be added to the payout total for each class.</p>
                  </div>
                </div>
                <template v-if="payoutGroup.class_size_variation">
                  <div v-for="(row, i) in payoutGroup.class_size_placings" :key="i" class="flex space-x-2 items-center mb-1">
                    <div class="w-6 text-sm">{{i+1}}</div>
                    <div v-for="(col, j) in row" :key="j">
                      <input type="number" class="block w-16 text-center rounded p-1 border border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm" v-model.number="payoutGroup.class_size_placings[i][j]">
                    </div>
                    <button @click="row.push([])" type="button" class="rounded-full bg-indigo-600 px-2 py-1 text-xs text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">+ Place</button>

                  </div>
                  <button type="button" @click="payoutGroup.class_size_placings.push([])" class="rounded-full bg-white px-2.5 py-1 text-xs font-semibold text-gray-900 shadow-sm border ring-inset ring-gray-300 hover:bg-gray-50">+ Row</button>

                </template>
                <template v-else>
                  <div v-for="(c, j) in payoutGroup.class_placings" :key="`${j}-c`" class="flex items-center justify-start w-20 pb-1">
                    <span class="w-6 text-sm">{{j+1}}:</span>
                    <input type="number" class="block w-16 text-center rounded p-1 border border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm" v-model.number="payoutGroup.class_placings[j]">
                  </div>
                </template>
              </div>
              <div v-if="payoutGroup.division_champions">
                <div class="p-1 mb-2 border-b text-lg">
                  <p>Division Placings</p>
                  <div class="flex space-x-2 items-center">
                    <div class="relative flex items-start">
                      <div class="flex h-5 items-center">
                        <input v-model="payoutGroup.division_percentage_based" id="comments" aria-describedby="comments-description" name="comments" type="checkbox" class="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500">
                      </div>
                      <div class="ml-3 text-sm">
                        <label for="comments" class="font-medium text-gray-700">Percentage based?</label>
                      </div>
                    </div>
                    <div v-if="payoutGroup.division_percentage_based" class="flex items-center">
                        <label class="font-medium text-gray-700 text-sm mr-1">Added Money?</label>
                        <input v-model.number="payoutGroup.division_added_money" type="number" class="border p-1 rounded w-16 text-sm">
                        <p class="ml-1 text-xs font-medium">**This amount will be added to the payout total for each division.</p>
                    </div>
                  </div>
                </div>
                <template v-if="payoutGroup.division_champions.default">
                  Default
                  <div v-for="(k, x) in Object.keys(payoutGroup.division_champions.default)" :key="`${x}-da`" class="flex items-center justify-start w-64 pb-0.5 ml-3">
                    <span class="w-56 text-sm">{{k.replace('^','')}}:</span>
                    <input type="number" class="block w-16 text-center rounded p-0.5 border border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm" v-model.number="payoutGroup.division_champions.default[k]">
                  </div>
                </template>
                <div v-for="(t, j) in Object.keys(payoutGroup.division_champions)" :key="j">
                  <template v-if="t !== 'default'">
                    {{t}}
                    <div v-for="(k, y) in Object.keys(payoutGroup.division_champions[t])" :key="`${y}-d`" class="flex items-center justify-start w-64 pb-0.5 ml-3">
                      <span class="w-56 text-sm">{{k.replace('^','')}}:</span>
                      <input type="number" class="block w-16 text-center rounded p-0.5 border border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm" v-model.number="payoutGroup.division_champions[t][k]">
                    </div>
                  </template>
                </div>
              </div>
              <div v-if="payoutGroup.overall_champions">
                <div class="p-1 mb-2 border-b text-lg">
                  <p>Overall Placings</p>
                  <div class="flex items-center w-full space-x-2">
                    <div class="relative flex items-start items-center">
                      <div class="flex h-5 items-center">
                        <input v-model="payoutGroup.overall_percentage_based" id="comments" aria-describedby="comments-description" name="comments" type="checkbox" class="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500">
                      </div>
                      <div class="ml-3 text-sm">
                        <label for="comments" class="font-medium text-gray-700">Percentage based?</label>
                      </div>
                    </div>
                    <div v-if="payoutGroup.overall_percentage_based" class="flex items-center">
                      <label class="font-medium text-gray-700 text-sm mr-1">Added Money?</label>
                      <input v-model.number="payoutGroup.overall_added_money" type="number" class="border p-1 rounded w-16 text-sm">
                    </div>
                  </div>
                </div>
                <div v-for="(k, j) in Object.keys(payoutGroup.overall_champions)" :key="`${j}-o`" class="flex items-center justify-start w-64 pb-1">
                  <span class="w-56 text-sm">{{k.replace('^','')}}:</span>
                  <input type="number" class="block w-16 text-center rounded p-1 border border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm" v-model.number="payoutGroup.overall_champions[k]">
                </div>
              </div>
            </div>
          </template>
        </div>
      </tab>
      <tab name="Raw Settings" v-if="currentUser.user_id === 'Clo1Va5v4pNuvE1TqHPNeKWFGay2'">
        <div class="my-2 flex justify-end space-x-3">
          <button class="btn btn-blue" @click="updateEvent">Save Settings</button>
        </div>
        <v-jsoneditor v-model="adminData.event.event_settings.premium_payout_settings" :options="{mode:'code'}" :plus="false" height="700px" class="mb-4"/>
      </tab>
    </tabs>
    <b-modal  ref="premiumDetailsModal" :title="`Payout Details`" size="lg" no-close-on-backdrop hide-footer>
      <div v-if="selectedGroup">
        <div class="mb-4 p-4 bg-gray-200 border-_b rounded flex justify-between">
          <div>
            <p class="text-xs font-bold mb-2">EXHIBITOR DETAILS</p>
            <p class="text-lg"> {{ selectedGroupName }}</p>
            <p class="text-sm">{{selectedGroup.user.address.address_line1}}</p>
            <p class="text-sm">{{selectedGroup.user.address.city}}, {{selectedGroup.user.address.state}} {{selectedGroup.user.address.zip}}</p>
            <p class="text-sm">{{selectedGroup.user.phone_number}}</p>
          </div>
          <div>
            <p class="text-xs font-bold mb-2">EVENT DETAILS</p>
            <p class="text-lg"> {{ event.name }}</p>
            <p class="text-sm">{{event.location_details.address}}</p>
            <p class="text-sm">{{event.location_details.city}}, {{event.location_details.state}} {{event.location_details.zip}}</p>
          </div>
        </div>
        <showman-table :tableData="selectedGroup.details" :tableFields="detailFields" :condensed="true" class="text-sm md:text-base">
          <div slot="show_name" slot-scope="data">
            <p class="">{{data.item.show_name}}</p>
          </div>
          <div slot="amount" slot-scope="data" class="text-right">
            <p class="">{{currencySymbol}}{{data.item.amount.toFixed(2)}}</p>
          </div>
        </showman-table>
      </div>
    </b-modal>
    <DownloadData ref="downloadData"/>

  </div>
</template>

<script>
import VJsoneditor from 'v-jsoneditor'
import DownloadData from '@/components/DownloadData'
import premiumCalculation from '../../premiumCalculation'

export default {
  components: {
    VJsoneditor,
    DownloadData
  },
  data () {
    return {
      premiumGroups: {},
      selectedGroup: null,
      payoutGroup: null,
      premiumFields: [
        {key: 'exhibitor', position: 'left'},
        {key: 'address', position: 'left'},
        {key: 'premium_total', position: ''}
      ],
      detailFields: [
        {key: 'show_name', position: 'left'},
        {key: 'animal_id', position: 'left'},
        {key: 'type', position: 'left'},
        {key: 'amount', position: 'right'}
      ]
    }
  },
  methods: {
    viewPremiumDetails (selected) {
      this.selectedGroup = selected
      this.$refs.premiumDetailsModal.show()
    },
    getPayoutData () {
      this.axios.get(`${process.env.VUE_APP_ROOT_API}/premiums/getPayoutData?event_id=${this.adminData.event.event_id}`)
        .then(response => {
          let showResults = response.data.data.show_results
          this.premiumGroups = premiumCalculation.calculateEventPremiums(this.payoutSettings, showResults, this.adminData.event.shows)
          /* showResults.forEach(sr => {
            let payoutGroup = this.payoutSettings.payout_groups.find(pg => {
              if (pg.shows.some(s => s.show_id === sr.show_id)) {
                return pg
              }
            })
            if (sr.show_book) {
              sr.show_book.forEach(c => {
                if (c.entryType === 'standard') {
                  c.entries.forEach(e => {
                    if (e.place) {
                      let totalAmount = 0
                      let classSize = c.entries.filter(e => e.place !== 'SCRATCH').length
                      if (payoutGroup.class_percentage_based) {
                        let show = this.adminData.event.shows.find(s => s.show_id === sr.show_id)
                        totalAmount = show.pricing_details.rate * classSize
                        // Check for added money
                        if (payoutGroup.class_added_money) {
                          totalAmount += payoutGroup.class_added_money
                        }
                      }
                      if (payoutGroup.class_size_variation) {
                        if (parseInt(e.place)) {
                          let amount = payoutGroup.class_size_placings[classSize - 1][e.place - 1]
                          if (payoutGroup.class_percentage_based) {
                            amount = totalAmount * (amount / 100)
                          }
                          if (amount) {
                            this.addToPremiumGroup_standard(e, payoutGroup, sr.name, amount)
                          }
                        }
                      } else {
                        let amount = payoutGroup.class_placings[e.place - 1]
                        if (payoutGroup.class_percentage_based) {
                          amount = totalAmount * (amount / 100)
                        }
                        if (amount) {
                          this.addToPremiumGroup_standard(e, payoutGroup, sr.name, amount)
                        }
                      }
                    }
                  })
                } else if (c.entryType === 'Champion') {
                  if (!c.settings) {
                    c.settings = {}
                  }
                  // if (c.winner && (c.settings ? c.settings.champion_type !== 'WRITE' : true)) {
                  if (c.winner && c.settings.champion_type !== 'WRITE') {
                    let exhibitorID = c.winner.exhibitor_id
                    if (!exhibitorID) {
                      sr.show_book.forEach(cl => {
                        if (cl.entryType === 'standard') {
                          cl.entries.forEach(e => {
                            if (c.winner.entry_id === e.entry_id) {
                              exhibitorID = e.exhibitor.exhibitor_id
                            }
                          })
                        }
                      })
                    }
                    if (c.division === 'Overall') {
                      if (payoutGroup.overall_champions) {
                        this.addToPremiumGroup_overall(exhibitorID, payoutGroup, sr.name, c, sr)
                      }
                    } else {
                      if (payoutGroup.division_champions) {
                        this.addToPremiumGroup_division(exhibitorID, payoutGroup, sr.name, c, sr)
                      }
                    }
                  }
                }
              })
            }
          }) */
        })
    },
    addToPremiumGroup_standard (entry, payoutGroup, showName, amount) {
      if (!this.premiumGroups[entry.exhibitor.exhibitor_id]) {
        this.premiumGroups[entry.exhibitor.exhibitor_id] = {
          premium_total: amount,
          details: [
            {
              show_name: showName,
              animal_id: entry.entry_details.animal_id,
              amount: amount,
              division: entry.division,
              placing: entry.place,
              type: 'Class Placing'
            }
          ]
        }
      } else {
        this.premiumGroups[entry.exhibitor.exhibitor_id].premium_total += amount
        this.premiumGroups[entry.exhibitor.exhibitor_id].details.push({
          show_name: showName,
          amount: amount,
          animal_id: entry.entry_details.animal_id,
          division: entry.division,
          placing: entry.place,
          type: 'Class Placing'

        })
      }
    },
    addToPremiumGroup_overall (exhibitorID, payoutGroup, showName, c, sr) {
      let amount = 0
      let totalAmount = 0
      if (payoutGroup.overall_percentage_based) {
        let divisionSize = 0
        sr.show_book.forEach(cl => {
          if (cl.entryType === 'standard') {
            divisionSize += cl.entries.filter(e => e.place !== 'SCRATCH').length
          }
        })
        let show = this.adminData.event.shows.find(s => s.show_id === sr.show_id)
        totalAmount = show.pricing_details.rate * divisionSize
        // Check for added money
        if (payoutGroup.overall_added_money) {
          totalAmount += payoutGroup.overall_added_money
        }
      }
      Object.keys(payoutGroup.overall_champions).forEach(k => {
        const regex = new RegExp(k, 'gi')
        if (c.calculated_class_name ? c.calculated_class_name.match(regex) : c.class_name.match(regex)) {
          if (payoutGroup.overall_percentage_based) {
            amount = totalAmount * (payoutGroup.overall_champions[k] / 100)
          } else {
            amount = payoutGroup.overall_champions[k]
          }
        }
      })
      if (this.premiumGroups[exhibitorID]) {
        this.premiumGroups[exhibitorID].premium_total += amount
        this.premiumGroups[exhibitorID].details.push({
          show_name: showName,
          amount: amount,
          animal_id: c.winner.animal_id,
          division: c.division,
          type: 'Overall Placing'
        })
      } else {
        this.premiumGroups[exhibitorID] = {
          premium_total: amount,
          details: [
            {
              show_name: showName,
              amount: amount,
              animal_id: c.winner.animal_id,
              division: c.division,
              type: 'Overall Placing'
            }
          ]
        }
      }
    },
    addToPremiumGroup_division (exhibitorID, payoutGroup, showName, c, sr) {
      let amount = 0
      let totalAmount = 0
      if (payoutGroup.division_percentage_based) {
        let divisionSize = 0
        sr.show_book.filter(cl => cl.division === c.division).forEach(cl => {
          if (cl.entryType === 'standard') {
            divisionSize += cl.entries.filter(e => e.place !== 'SCRATCH').length
          }
        })
        let show = this.adminData.event.shows.find(s => s.show_id === sr.show_id)
        totalAmount = show.pricing_details.rate * divisionSize
        // Check for added money
        if (payoutGroup.division_added_money) {
          totalAmount += payoutGroup.division_added_money
        }
      }
      let divisionGroup = payoutGroup.division_champions[c.division] ? payoutGroup.division_champions[c.division] : payoutGroup.division_champions.default
      if (divisionGroup) {
        Object.keys(divisionGroup).forEach(k => {
          const regex = new RegExp(k, 'gi')
          if (c.calculated_class_name ? c.calculated_class_name.match(regex) : c.class_name.match(regex)) {
            if (payoutGroup.division_percentage_based) {
              amount = totalAmount * (divisionGroup[k] / 100)
            } else {
              amount = divisionGroup[k]
            }
          }
        })
        // Need to add so that it will add if misssing
        if (this.premiumGroups[exhibitorID]) {
          this.premiumGroups[exhibitorID].premium_total += amount
          this.premiumGroups[exhibitorID].details.push({
            show_name: showName,
            amount: amount,
            animal_id: c.winner.animal_id,
            division: c.division,
            type: `Division Placing (${c.division})`
          })
        } else {
          this.premiumGroups[exhibitorID] = {
            premium_total: amount,
            details: [
              {
                show_name: showName,
                animal_id: c.winner.animal_id,
                amount: amount,
                division: c.division,
                type: `Division Placing (${c.division})`
              }
            ]
          }
        }
      }
    },
    updateEvent () {
      this.$store.dispatch('updateEvent', this.event)
        .then(response => {
          this.notie.alert({
            type: 1,
            text: `Event, ${this.event.name} Successfully Updated`
          })
        })
        .catch(() => {
          // this.$honeybadger.notify(error)
          this.notie.alert({
            type: 3,
            text: `Error updating event, please check all fields and try again.<br>You can send an email to <b>${process.env.VUE_APP_SUPPORT_EMAIL}</b> if the error continues.`
          })
        })
    },
    findExhibitor (exhibitorID) {
      return this.adminData.exhibitors.find(e => e.exhibitor_id === exhibitorID)
    },
    findUser (userID) {
      return this.adminData.entry_groups.find(eg => eg.user.user_id === userID).user
    }
  },
  computed: {
    premiumList () {
      let list = []
      Object.keys(this.premiumGroups).forEach((exhibitorID) => {
        let group = this.premiumGroups[exhibitorID]
        let exhibitorPremium = {
          exhibitor_id: exhibitorID,
          premium_total: group.premium_total,
          details: group.details.filter(d => d.amount > 0),
          exhibitor: this.findExhibitor(exhibitorID)
        }
        if (exhibitorPremium.exhibitor) {
          exhibitorPremium.user = this.findUser(exhibitorPremium.exhibitor.user_id)
          list.push(exhibitorPremium)
        }
      })
      list.forEach(pg => {
        pg.details.sort((a, b) => {
          return b.amount - a.amount
        })
      })
      return list.sort((a, b) => b.premium_total - a.premium_total)
    },
    currentUser () {
      return this.$store.state.user
    },
    payoutSettings () {
      return this.adminData.event.event_settings.premium_payout_settings
    },
    adminData () {
      return this.$store.state.admin.adminData
    },
    event () {
      return this.adminData.event
    },
    selectedGroupName () {
      if (this.selectedGroup) {
        return `${this.selectedGroup.exhibitor.first_name} ${this.selectedGroup.exhibitor.last_name}`
      } else {
        return ''
      }
    },
    premiumPayoutdata () {
      let data = []
      this.premiumList.forEach(p => {
        data.push({
          first_name: p.exhibitor.first_name,
          last_name: p.exhibitor.last_name,
          exhibitor_id: p.exhibitor_id,
          premium_total: p.premium_total,
          address: p.user.address.address_line1,
          city: p.user.address.city,
          state: p.user.address.state,
          zip: p.user.address.zip,
          email: p.user.email,
          phone_number: p.user.phone_number
        })
      })
      return data
    },
    premiumHeaders () {
      return [
        {
          field: 'first_name',
          header: 'First Name'
        },
        {
          field: 'last_name',
          header: 'Last Name'
        },
        {
          field: 'premium_total',
          header: 'Premium Total'
        },
        {
          field: 'email',
          header: 'Email'
        },
        {
          field: 'phone_number',
          header: 'Phone Number'
        },
        {
          field: 'address',
          header: 'Address'
        },
        {
          field: 'city',
          header: 'City'
        },
        {
          field: 'state',
          header: 'State'
        },
        {
          field: 'zip',
          header: 'Zip Code'
        },
        {
          field: 'exhibitor_id',
          header: 'Exhibitor ID'
        }
      ]
    },
    showList () {
      let list = []
      this.adminData.event.shows.forEach(s => {
        list.push({
          name: s.name,
          value: s.show_id,
          show_id: s.show_id
        })
      })
      return list
    },
    currencySymbol () {
      return this.Localized.getCurrencyInfo(this.event.location_details.country).symbol
    }
  }
}
</script>

<style>

</style>
